import React from 'react';
import PropTypes from 'prop-types';

import CutoffField from './CutoffField';

class CutoffsFieldsComponent extends React.PureComponent {
  renderLeftField = (inputClassName, label, wrapperClass) => (
    <CutoffField
      id="left-cutoff"
      name="leftCutoff"
      label={label}
      inputClass={inputClassName}
      wrapperClass={wrapperClass}
      onChange={this.props.onLeftCutoffChange}
      validate={this.props.validateLeftCutoffFn}
    />
  )

  renderRightField = (inputClassName, label, wrapperClass) => (
    <CutoffField
      id="right-cutoff"
      name="rightCutoff"
      label={label}
      inputClass={inputClassName}
      wrapperClass={wrapperClass}
      onChange={this.props.onRightCutoffChange}
      validate={this.props.validateRightCutoffFn}
    />
  )

  render () {
    return (
      <div>
        {this.props.isLeftCutoffFieldVisible && !this.props.isRightCutoffFieldVisible && (
          <div className="flex baseline main-input--inline mb-5 width-48">
            {this.renderLeftField('', 'P( x \u2264', 'width-full ')}
            <span className="main-input__label mr--5">)</span>
          </div>
        )}

        {this.props.isRightCutoffFieldVisible && !this.props.isLeftCutoffFieldVisible && (
          <div className="flex baseline main-input--inline mb-5 width-48">
            {this.renderRightField('', 'P( x \u2265', 'width-full ')}
            <span className="main-input__label mr--5">)</span>
          </div>
        )}

        {this.props.isRightCutoffFieldVisible && this.props.isLeftCutoffFieldVisible && !this.props.isCenterCutoffChosen && (
          <div className="flex space-between main-input--inline">
            {this.renderLeftField('', 'P( x \u2264', 'width-48 ')}
            <div className="flex baseline main-input--inline mb-5 width-48">
              {this.renderRightField('', ' or x \u2265', ' width-full')}
              <span className="main-input__label mr--5">)</span>
            </div>
          </div>
        )}

        {this.props.isRightCutoffFieldVisible && this.props.isLeftCutoffFieldVisible && this.props.isCenterCutoffChosen && (
          <div className="flex space-between main-input--inline">
            {this.renderLeftField('', 'P( x \u2265', 'width-48 ')}
            <div className="flex baseline main-input--inline mb-5 width-48">
              {this.renderRightField('max-80', 'and x \u2264', ' width-full')}
              <span className="main-input__label mr--5">)</span>
            </div>
          </div>
        )}
      </div>
    );
  }
}

CutoffsFieldsComponent.propTypes = {
  isLeftCutoffFieldVisible: PropTypes.bool.isRequired,
  isRightCutoffFieldVisible: PropTypes.bool.isRequired,
  isCenterCutoffChosen: PropTypes.bool.isRequired,

  onLeftCutoffChange: PropTypes.func.isRequired,
  onRightCutoffChange: PropTypes.func.isRequired,

  validateLeftCutoffFn: PropTypes.func.isRequired,
  validateRightCutoffFn: PropTypes.func.isRequired
};

export default CutoffsFieldsComponent;
